import { Box, Button, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React from "react";
import { STATES } from "../../constants.ts";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LockIcon from '@mui/icons-material/Lock';

interface User {
  user_id: string;
  full_name: string;
  email: string;
  phone: string;
  password: string;
  is_admin: boolean;
  last_login: string;
  states: string[]; // stores state CODES (e.g., 'NC')
  custom_message?: string;
}

const AddUserForm = ({
  handleAddUser, 
  newUser, 
  setNewUser }: { 
    handleAddUser: (e: React.FormEvent) => void; 
    newUser: User; 
    setNewUser: (arg: User) => void;}) => {
  return (
    <Box component="form" onSubmit={handleAddUser} display="flex" flexWrap="wrap" gap={2}>
    <TextField
      label="Full Name"
      value={newUser.full_name}
      onChange={(e) => setNewUser({ ...newUser, full_name: e.target.value })}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AccountCircleIcon />
          </InputAdornment>
        ),
      }}
    />
    <TextField
      label="Email"
      type="email"
      value={newUser.email}
      onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <EmailIcon />
          </InputAdornment>
        ),
      }}
    />
    <TextField
      label="Phone"
      type="tel"
      value={newUser.phone}
      onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PhoneIcon />
          </InputAdornment>
        ),
      }}
    />
    <TextField
      label="Password"
      type="password"
      value={newUser.password}
      onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <LockIcon />
          </InputAdornment>
        ),
      }}
    />
    <FormControl fullWidth>
      <InputLabel>States</InputLabel>
      <Select
        multiple
        value={newUser.states}
        onChange={(e) => setNewUser({ ...newUser, states: e.target.value as string[] })}
        label="States"
      >
        {STATES.map(({ code, name }) => (
          <MenuItem key={code} value={code}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl fullWidth>
      <InputLabel>User Role</InputLabel>
      <Select
        value={newUser.is_admin ? 'Admin' : 'User'}
        onChange={(e) => setNewUser({ ...newUser, is_admin: e.target.value === 'Admin' })}
        label="User Role"
      >
        <MenuItem value="User">User</MenuItem>
        <MenuItem value="Admin">Admin</MenuItem>
      </Select>
    </FormControl>
    <Divider sx={{ width: '100%' }} />
    <Button type="submit" variant="contained" color="primary" sx={{ alignSelf: 'flex-end' }}>
      Add User
    </Button>
  </Box>
  );
}

export default AddUserForm;